<template>
  <base-card>
    <h2>Find Your Coach</h2>
    <!-- @change event je listener za vsakič ko se vrednost spremeni iz checked / unchecked -->
    <span class="filter-option">
      <input type="checkbox" id="frontend" checked @change="setFilter" />
      <label for="frontend">Frontend</label>
    </span>

    <span class="filter-option">
      <input type="checkbox" id="backend" checked @change="setFilter" />
      <label for="backend">Backend</label>
    </span>

    <span class="filter-option">
      <input type="checkbox" id="career" checked @change="setFilter" />
      <label for="career">Career</label>
    </span>
  </base-card>
</template>

<script>
export default {
  emits: ['change-filter'],
  data() {
    return {
      // če je true, coachi s tem expertisom so prikazani
      filters: {
        frontend: true,
        backend: true,
        career: true,
      },
    };
  },
  methods: {
    // metoda ki se sproži vsakič ko se preko @change vrednost spremeni
    // event je value ki se zgodi preko @change
    setFilter(event) {
      // extraktamo 2 informacije preko tega eventa

      // event target id se nanaša na id v checkboxu zgoraj npr id="frontend"
      const inputId = event.target.id;
      // ali je ta element checked ali unchecked npr frontend
      const isActive = event.target.checked;
      // nato dostopamo do filters object v data()
      // ... s spread operatorjom jih kopiramo v nov objekt ki smo ga ustvarili (updatedFiltes)
      const updatedFilters = {
        ...this.filters,
        // s tem dinamično nastavimo enega izmed value-ov in ga dodelimo inputId ki smo ga definirali zgoraj
        [inputId]: isActive,
      };
      // nazadnje filtre updatamo z novo vrednostjo
      this.filters = updatedFilters;
      // preko emit sporočamo komponentam ki uporabljajo filter da vejo za njega.
      // custom event preko katerega komuniciramo nazaj v parent komponenti
      // change-filter bo event, ki nosi updatedFilters
      this.$emit('change-filter', updatedFilters);
    },
  },
};
</script>

<style scoped>
h2 {
  margin: 0.5rem 0;
}

.filter-option {
  margin-right: 1rem;
}

.filter-option label,
.filter-option input {
  vertical-align: middle;
}

.filter-option label {
  margin-left: 0.25rem;
}

.filter-option.active label {
  font-weight: bold;
}
</style>
